import React, { useState } from "react";
import CodeMirror from "@uiw/react-codemirror";
import { langs } from "@uiw/codemirror-extensions-langs";
import { vscodeLight } from "@uiw/codemirror-theme-vscode";

const CodeEditor = ({ language, value, onChange, label }) => {
  return (
    <div className="editor-context">
      <label>{label}</label>
      <div>
        <CodeMirror
          value={value}
          height="200px"
          theme={vscodeLight}
          extensions={[langs[language]()]}
          onChange={(val) => onChange(val)}
        />
      </div>


    </div>

  );
};

export default CodeEditor

